<template>
  <div class="modal custom-modal fade" id="registerModal" tabindex="-1" aria-labelledby="registerModal" 
  aria-hidden="true" data-bs-keyboard="false" data-bs-backdrop="static">
    <div class="modal-dialog modal modal-dialog-centered">
      <div class="modal-content">

        <div class="modal-body">
          <!-- <button type="button" class="custom-close-btn" data-bs-dismiss="modal" aria-label="Close">x</button> -->

          <div class="container-fluid">

            <div class="row px-3 px-sm-5 py-3">
              <div class="col-12 text-center">
                <p class="register-modal__title" v-if="!isExternalAppointment">{{ t('register-modal.title') }}</p>
                
                <p class="register-modal__indication" v-if="isExternalAppointment">{{ t('register-modal.title-external') }}</p>

                <img class="register-modal__image mb-3" src="@/assets/landingpage/Psicologas.png" alt="Psicologos">

                <p class="register-modal__indication">{{ t('register-modal.indication' + (isExternalAppointment ? '-external': '')) }}</p>

                <form @submit.prevent="register">
                  <div class="row gx-2">
                    <div class="col-12 col-md-6">
                      <div class="form-group has-validation mb-2">
                        <input type="text" class="form-control" v-model="user.name" :placeholder="t('register-modal.user-name')">
                      </div>
                    </div>

                    <div class="col-12 col-md-6">
                      <div class="form-group has-validation mb-2">
                        <input type="text" class="form-control" v-model="user.last_name" :placeholder="t('register-modal.last-name')">
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="form-group has-validation mb-2">
                        <input type="text" v-model="user.birthdate" id="birthdateInput"
                          :placeholder="t('register-modal.birth-date')" class="form-control dateInput"
                          autocomplete="off">
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="form-group has-validation mb-2 text-start">
                        <input type="text" v-model="user.phone" class="form-control phone" minlength="10" maxlength="15" :placeholder="t('register-modal.phone')">

                        <span class="error-label" v-if="user.phone && user.phone != '' && (user.phone).length < 10">*
                          {{ t('general-messages.phone-min-alert-text') }}</span>

                        <span class="error-label" v-if="user.phone && user.phone != '' && (user.phone).length > 15">*
                          {{ t('general-messages.phone-max-alert-text') }}</span>
                      </div>
                    </div>


                    <div class="col-12">
                      <div class="form-group has-validation mb-2">
                        <input type="email" class="form-control" v-model="user.email" :placeholder="t('register-modal.email')">
                      </div>
                    </div>

                    <div class="col-12">
                      <div class="form-group has-validation mb-2 pos-relative">
                        <input id="passInput" type="password" class="form-control has-validation-tooltip" v-model="user.password" :placeholder="t('register-modal.password')">
                        <!-- <question-mark :text="t('register-modal.password-validations')"></question-mark> -->
                        <img id="eyeIcon" class="eye-icon" :src="require(showingPassword ? '@/assets/images/eye-slash.svg' : '@/assets/images/eye.svg')" alt="icon" :class="(user.password) ? '' : 'd-none'" @click.prevent="togglePassword">
                        <pass-validation-tooltip :password="user.password">{{ t('tooltip-pass.title') }}</pass-validation-tooltip>
                      </div>
                    </div>

                    <div class="col-12">
                      <button type="submit" class="btn mm-btn mm-btn-secondary uppercase full-width" :disabled="isDisabled">
                        {{ t('register-modal.' + (isExternalAppointment ? 'register' : 'see-psicologists')) }}
                      </button>
                    </div>
                  </div>
                </form>

                <p class="register-modal__terms mt-4 mb-0 fs-14">{{ t('register-modal.terms' + (isExternalAppointment ? '-external': '')) }} <a class="cursor-pointer" @click.prevent="goToTerms">{{ t('register-modal.terms-conditions') }}</a></p><!--<router-link :to="{name: 'terms-and-conditions'}">{{ t('register-modal.terms-conditions') }}</router-link>-->

                <div class="row align-items-center">
                  <div class="col-12 text-center mb-1">
                    <span class="divider"></span>
                  </div>

                  <div class="col-12">
                    <span class="register-modal__login fs-14 me-2">{{ t('register-modal.has-account') }}</span>
                    <button class="login-link btn btn-link no-decoration fs-14" @click.prevent="goToLogin">{{ t('register-modal.login') }}</button>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import {useI18n} from "vue-i18n"
  import {computed, onMounted, ref} from 'vue'
  import {useStore} from "vuex"
  import {useRouter} from 'vue-router'
  import useAuthStore from '@/modules/principal/composables/useAuthStore'
  import QuestionMark from '@/components/shared/QuestionMark.vue'
  import moment from 'moment'
  import { getBrowserName } from '@/utils/domUtil'
  import PassValidationTooltip from '@/components/shared/PassValidationTooltip.vue'
import { useGtm } from '@gtm-support/vue-gtm';

  export default {
    components: { 
      QuestionMark,
      PassValidationTooltip
     },
    emits: ['registerUser'],
    props: {
      isExternalAppointment: {
        type: Boolean,
        required: false,
        default: false,
      },
      psychologistId: {
        type: Number,
        required: false,
        default: null
      }
    },
    setup(props, { emit }) {
      const gtm = useGtm();
      const {t} = useI18n()
      const store = useStore()
      const regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
      const regexPasword = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9"\\])[^\\"\\]{8,}$/
      // const regexPasword = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9"])[^"]{8,}$/
      const showingPassword = ref(false)
      const router = useRouter()

      const {
        user,
        keysError,
        registerUser,
      } = useAuthStore();
            
      const uuid = computed(()=> store.getters['auth/getMetricsUUID']);

      const isDisabled = computed(() => {        
        if (!user.value.name) {
          return true
        }
        if (!user.value.last_name) {
          return true
        }
        if (!user.value.birthdate) {
          return true
        }
        if (!user.value.phone) {
          return true
        }
        if (!user.value.email) {
          return true
        }          
        if (!user.value.password) {
          return true
        }        
        /* if (!regex.test(user.value.email)) {
          return true
        } */
        if (!regexPasword.test(user.value.password)) {
          return true
        }
        return false
      })

      const register = async () => {
        if (props.isExternalAppointment) {
          user.value.psychologist_id = props.psychologistId
        }
        const {error} = await registerUser()
        if (!error) {
          emit('registerUser');
          gtm.trackEvent({
              event: 'evFlowStep3',
              fecha_nacimiento: user.value.birthdate,
              num_whatsapp: user.value.phone,
              email: user.value.email,
          });
        }
      }

      const togglePassword = () => {
        const input = document.getElementById('passInput')

        if (input.type === "password") {
          input.type = "text";
          showingPassword.value = true
        } else {
          input.type = "password";
          showingPassword.value = false
        }
      }

      const goToTerms = () => {
        // Save user data temporary
        if (Object.keys(user.value).length) {
          let registerValues = Object.assign({}, user.value)
          delete registerValues.password
          sessionStorage.setItem("registerData", JSON.stringify(registerValues));
        }

        router.push({name: 'terms-and-conditions'})
      }

      const goToLogin = () => {
        const registerModal = document.querySelector('#registerModal')
        const modal = bootstrap.Modal.getOrCreateInstance(registerModal)
        modal.hide()

        const loginModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('loginModal'))
        loginModal.show()

        // router.push({name: 'login-page'})
      }

      onMounted(async () => {
        // Datepickers init
        $("#birthdateInput").datepicker({
          dateFormat: 'yy/mm/dd',
          changeMonth: true,
          changeYear: true,
          maxDate: moment(new Date).subtract(12, 'years').format("YYYY/MM/DD"),
          yearRange: "-100:-12",
          onSelect: (selectedDate) => {
            user.value.birthdate = selectedDate
          }
        })

        $(".phone").mask('000000000000000');

        // Set user data previous saved
        let regValues = JSON.parse(sessionStorage.getItem('registerData')) || {}
        user.value = regValues
        sessionStorage.removeItem('registerData');

        const metric = {
          type_metric_id: 4,
          uuid: uuid.value
        }
      })

      return {
        isDisabled,
        user,
        showingPassword,
        t,        
        register,
        togglePassword,
        goToLogin,
        goToTerms
      }
    }
  }
</script>

<style scoped>

.pos-relative {
  position: relative;
}

.custom-modal.fade.show {
  background: rgba(255,255,255,0.5);
}

#registerModal .modal {
  max-width: 550px !important;
}

.register-modal__title,
.register-modal__indication {
  font-family: var(--mm-font-basier-circle);
  font-size: 18px;
  font-weight: 400;
  margin-bottom: 15px;
  color: var(--mm-medium-dark);
}

.register-modal__indication {
  font-size: 16px;
}

.register-modal__image {
  max-width: 85%;
}

#registerModal input {
  padding: 10px 12px;
  border-radius: 8px;
  /* border-color: #D1D1D1; */
  font-size: 14px !important;
}

#registerModal input:focus {
  box-shadow: inset 0 1px 1px rgb(210 232 253 / 8%), 0 0 8px rgb(210 232 253 / 60%);
  border-color: rgba(210,232,253,.8);
}

::placeholder {
  color: var(--mm-primary);
  text-transform: uppercase;
  font-weight: 400;
}

:-ms-input-placeholder {
  color: var(--mm-primary);
  text-transform: uppercase;
  font-weight: 400;
}

::-ms-input-placeholder {
  color: var(--mm-primary);
  text-transform: uppercase;
  font-weight: 400;
}

.form-group input, .form-group select, .form-group textarea {
  border: 1px solid rgba(var(--mm-surface-two-rgb), 0.5) !important;
  color: var(--mm-primary) !important;
  font-family: var(--mm-font-gt-america-mono);
  font-weight: 400 !important;
  font-size: 16px;
}

.mm-btn-secondary {
  min-height: 43px;
}

.register-modal__terms,
.register-modal__terms a,
.register-modal__login {
  color: var(--mm-surface-two);
  font-family: var(--mm-font-basier-circle);
}
.register-modal__terms a,
.login-link {
  color: var(--mm-primary);
  text-decoration: underline !important;
  font-family: var(--mm-font-basier-circle);
}

.divider {
  width: 75%;
  display: inline-block;
  margin: 0 auto;
  border-bottom: 1px solid #d7d7d7;
}


.eye-icon {
  position: absolute;
  height: auto;
  width: 20px;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer !important;
}

/* Media queries */
  @media (min-width: 576px) {}

  @media (min-width: 768px) {
    .register-modal__image {
      max-width: 75%;
    }
  }

  @media (min-width: 992px) {}

  @media (min-width: 1200px) {}

  @media (min-width: 1400px) {}
</style>